import './useAutofillEvent.css';
export var autofillBackground = 'var(--_ttpug70-2-0-1)';
export var autofillCSS = '_ttpug73-2-0-1';
export var end = '_ttpug72-2-0-1';
export var start = '_ttpug71-2-0-1';